
import { cn } from "@/lib/utils";
import { ReactNode } from "react";

interface NeumorphicCardProps {
  title: string;
  icon?: ReactNode;
  description?: string;
  className?: string;
  children?: ReactNode;
  variant?: "default" | "elevated" | "pressed";
}

export function NeumorphicCard({
  title,
  icon,
  description,
  className,
  children,
  variant = "default",
}: NeumorphicCardProps) {
  // Determine shadow classes based on variant
  const variantClasses = {
    default: "shadow-[8px_8px_16px_0px_rgba(0,0,0,0.2),-8px_-8px_16px_0px_rgba(255,255,255,0.1)]",
    elevated: "shadow-[12px_12px_24px_0px_rgba(0,0,0,0.2),-8px_-8px_20px_0px_rgba(255,255,255,0.1)] transform -translate-y-1",
    pressed: "shadow-[inset_6px_6px_12px_0px_rgba(0,0,0,0.2),inset_-6px_-6px_12px_0px_rgba(255,255,255,0.1)]",
  };
  
  return (
    <div 
      className={cn(
        "bg-gradient-to-br from-blue-900/90 to-blue-950 rounded-xl p-6",
        "border border-blue-800/50",
        variantClasses[variant],
        "transition-all duration-300 hover:scale-[1.02]",
        className
      )}
    >
      <div className="flex items-start gap-4">
        {icon && (
          <div className="bg-gradient-to-br from-blue-500/80 to-blue-600 p-3 rounded-lg shadow-md">
            {icon}
          </div>
        )}
        <div className="flex-1">
          <h3 className="text-xl font-medium text-gray-100 mb-2">{title}</h3>
          {description && <p className="text-gray-300 mb-4">{description}</p>}
          <div className="text-gray-200">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
